module.exports = __webpack_public_path__ + "media/Enterprise.1924e701.svg";